<template>

    <div id="app" >
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'App',

    data() {
        return {
           
        };
    },
    created() {
        this.lastTime = new Date().getTime();
    },
    methods: {
        
    }
};
</script>
<style lang="scss">
@import './assets/css/main.css';
@font-face {
    font-family: 'PingFang SC';
    // src: url('./assets/css/theme-green/fonts/PingFang\ Bold.ttf');
    // src: url('./assets/css/theme-green/fonts/PingFang Regular.ttf');
    
    font-weight: normal;
    font-style: normal;
}
.u_xin{
    color: red;
}
.u_bottoms {
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
        width: 54px;
        height: 10.5px;
        margin-right: 30px;
    }
    .pan {
        font-size: 16px;
        font-weight: 500;
        color: rgba(160, 160, 160, 1);

    }
    
}

// @import './assets/css/color-dark.css'; 
.el-picker-panel {
    border: 1px solid #2b2b2b !important;
    background: #2b2b2b !important;
}
 
.el-year-table td .cell,.el-month-table  td .cell{
    color: rgba(245, 245, 245, 1)  !important;
}
.el-year-table .current  .cell,.el-month-table  .current  .cell{
    color: #409EFF !important;
}
.el-year-table td .cell:hover,.el-month-table  td .cell:hover{
    color: #409EFF !important;
}
.el-date-picker__header-label{
    color: rgba(245, 245, 245, 1)  !important;

}
.el-year-table td.today .cell,.el-month-table td.today .cell{
    font-weight: normal !important;
}
.el-popper .popper__arrow{
    display: none !important;

}
.el-picker-panel__icon-btn {
    color: rgba(245, 245, 245, 1)  !important;

}
.el-date-picker__header--bordered{
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
.el-select-dropdown{
    border: 1px solid #2b2b2b !important;
    background: #2b2b2b !important;

}
.el-select-dropdown__item{
    color: rgba(245, 245, 245, 1)  !important;

}
.el-select-dropdown__item.selected{
    color: #409EFF !important;
    font-weight: normal !important;

}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    font-size: 12px !important;
    color: #409EFF !important;
    background: none !important;
}

.el-select-dropdown__item{
    font-size: 12px !important;
}

.el-scrollbar__wrap{
    overflow: auto !important;
}
.el-cascader-panel{
    // border: 1px solid #2b2b2b !important;
    background: #2b2b2b !important;
}
 .el-cascader__dropdown{
    border:none !important;
    border: 1px solid #2b2b2b !important;
    
    background: #2b2b2b !important;

}
.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover{
    font-size: 12px !important;
    color: #409EFF !important;
    background: none !important;

}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
    font-weight: normal !important;
}
.el-cascader-menu {
    color: rgba(245, 245, 245, 1)  !important;

}
.el-avatar, .el-cascader-panel, .el-radio, .el-radio--medium.is-bordered .el-radio__label, .el-radio__label{
    font-size: 12px !important;

}
.el-date-table th{
    color: rgba(245, 245, 245, 1)  !important;

}
.el-picker-panel{
    color: rgba(245, 245, 245, 1)  !important;
    font-size: 12px !important;
}
.el-date-table td.today span{
    color: rgba(245, 245, 245, 1)  !important;
    font-weight: normal !important;
}
.el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div{
    background: none !important;
} 
.el-cascader-node.is-selectable.in-active-path{
    color: rgba(245, 245, 245, 1)  !important;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #409EFF !important;
}
.el-date-range-picker__time-header .el-input__inner{
    border: 1px solid #2b2b2b !important;
    color: rgba(245, 245, 245, 1)  !important;
    
    background: #2b2b2b !important;
}
.el-picker-panel__footer{
    background: #2b2b2b !important;

}
.el-time-panel{
    background: #2b2b2b !important;

}
.el-time-spinner__item {
    color: rgba(245, 245, 245, 1)  !important;
}
.el-time-spinner__item.active:not(.disabled){
    font-weight: normal !important;
    color: #409EFF !important;

}
.el-time-spinner__item:hover:not(.disabled):not(.active){
    background: none !important;
}
.el-time-panel__btn .cancel{
    color: rgba(245, 245, 245, 1)  !important;

}
.el-time-panel__btn {
    font-weight: normal !important;
}
.el-time-panel__footer .cancel{
    color: rgba(245, 245, 245, 1)  !important;

}
.el-time-panel__btn.confirm{

}
.el-cascader-menu{
    border-right: none !important;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    background: none !important;
}
.el-button{
    background: #5e5e5e !important;
    border: 1px solid #363636 !important;
    font-size: 12px !important;
    color: rgba(245, 245, 245, 1)  !important;
    line-height: normal !important;
} 
.el-message-box__btns .el-button{
    // background: initial !important;
    // border: initial !important;
    // font-size: initial !important;
    // color: initial  !important;
    // line-height: initial !important;
    background: #FFF !important;
    border: 0.083333rem solid #DCDFE6 !important;
    color: #606266 !important;
    line-height: 1 !important;

}
.el-message-box__btns .el-button--primary{
    color: #FFF !important;
    background-color: #409EFF !important;
    border-color: #409EFF !important;
}
.el-button--primary{
    background: #0073e6 !important;
}
.el-button--text {
    padding: 0.583333rem 1.25rem !important;
}

.el-picker-panel__footer .el-button--default{
    background: #0073e6 !important;

}
.el_inputs {
    border:none !important;
}


</style>
